import $ from 'jquery';

$(function() {
    // Pagination
    $('#post-list-button').on('click', function (e) {
        e.preventDefault();
        const $button = $(this);
        const total = parseInt($(this).data('total'), 10);
        const next = parseInt($(this).data('current'), 10) + 1;
        const generateRoute = (page) => `?paged=${page}`;

        $button.attr('disabled', true);
        $.ajax(generateRoute(next), {
            data: {
                ajax: true,
            },
        }).done(function (data) {
            $(data).appendTo('#post-list');
            $button.data('current', next);
            $button.attr('disabled', false);
            $button.attr('href', generateRoute(next + 1));
            if (next === total) {
                $button.remove();
            }
        }).fail(function () {
            $button.addClass('alert');
        });
    });
});
